import React, { Component } from "react";

import "../../css/Styles.css";

class BaetzBio extends Component {
  render() {
    return (
      <div>
        <h2>Bio</h2>
        <p>
          <strong>Bio:</strong> James will run a backyard ultra in Lucasville, OH starting on March 20, 2021. He will run as many 4.167 miles loops as he can starting every hour. The race ends when there is only one runner remaining.
        </p>
        
        <p>
          <strong>Adventure:</strong> Backyard Ultra
        </p>
        <p>
          <strong>Country:</strong> USA
        </p>
        <p>
          <strong>Sport:</strong> Running
        </p>
        <p>
          <strong>Favorite Phrase:</strong> Slow is smooth, and smooth is fast.
        </p>
      </div>
    );
  }
}

export default BaetzBio;